//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../GeometricAnalysis/GeometricAnalysis.DupinBuilder.js";
import "../no/ScCollector.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/GeometricAnalysis.js";
import "../no/ScCollector.js";
let d=[[[1,"Angle",0,"Expression",0],[1,"AngleDivisions",0,"Expression",0],[0,"AngleTolerance",1,0],[0,"ConstructionMethodOption",1,0],[0,"DistanceTolerance",1,0],[1,"DupinIndicatrix",0,"GeometricAnalysis.DupinBuilder",0],[0,"EvaluationPoint",1,"Point",0],[0,"EvaluationPointOption",1,0],[0,"HideConstructionProcess",1,0],[1,"Offset",0,"Expression",0],[1,"PlanarRadiusLimit",0,"Expression",0],[0,"PlaneOrientation",1,"Plane",0],[0,"PointOnFace",1,0],[0,"SpecifyDirection",1,"Direction",0],[1,"Surface",0,"ScCollector",0],[0,"Type",1,0]],[],[]];
SPLM.Features.ShipDesign.RollingLineBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.RollingLineBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.RollingLineBuilder.Types = Object.freeze({
    "Manual" : "Manual", "Pressure" : "Pressure", "Geodesic" : "Geodesic", "SteppedPressure" : "SteppedPressure"});

SPLM.Features.ShipDesign.RollingLineBuilder.StartEvaluationTypes = Object.freeze({
    "SheetMidpoint" : "SheetMidpoint", "PointOnFace" : "PointOnFace", "NewPoint" : "NewPoint"});

SPLM.Features.ShipDesign.RollingLineBuilder.ConstructionMethodTypes = Object.freeze({
    "MarchingAngle" : "MarchingAngle", "MarchingCurvature" : "MarchingCurvature", "ParallelPlane" : "ParallelPlane", "MinimumCurvature" : "MinimumCurvature", "MaximumCurvature" : "MaximumCurvature", "Highlight" : "Highlight", "Asymptote" : "Asymptote"});

export default SPLM;